module.exports = __webpack_public_path__ + "media/packs/users/img/icons/Help-06344b5e887090c46282cf663fdb8c30.svg";